export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";